// dashboard/conversationUser/index.tsx
import React, { useState } from "react";

// hooks
import { useProfile } from "../../../hooks";

// components
import UserHead from "./UserHead";
import Conversation from "./Conversation";
import ChatInputSection from "./ChatInputSection/index";

// types
import { IMessagesTypes } from "../../../types/message";
import { useAuth } from "../../../context/AuthContext";
import { useChat } from "../../../context/ChatContext";
import { useMessages } from "../../../context/MessagesContext";
import Loader from "../../../components/Loader";
import { pinnedTabs } from "../../../types/bookmarks";
import { useContacts } from "../../../hooks/useContacts";

interface IndexProps {
  isChannel: boolean;
  isBlocked: boolean;
  canSendFreeText: boolean;
  openUserDetails: () => void;
}

const Index = ({ openUserDetails, isChannel, isBlocked, canSendFreeText }: IndexProps) => {
  const { userProfile } = useProfile();
  const { user } = useAuth();
  const { contactsImage } = useContacts();

  const { selectedChatId, canOpenChat, conversationMessages, chatUserDetails } = useChat();
  const { loading, error, messages, sendMessage } = useMessages();
  const safeUser = chatUserDetails;


  /** ------------------- REPLY HANDLING ------------------- **/
  const [replyData, setReplyData] = useState<IMessagesTypes | null>(null);

  const onSetReplyData = (reply: IMessagesTypes | null) => {
    console.log("messageId", reply);
    alert('onOpenForward: ' + reply?.text)
    setReplyData(reply);
  }

  /** ------------------- SEND MESSAGE ------------------- **/
  const onSendMessage = async (data: any) => {
    // console.log("onSendMessage", data);

    if (!selectedChatId) return;

    const params: any = {
      iduser: userProfile?.id, //usuario logado
      idcontact: chatUserDetails?.basicDetails.id,
      name: chatUserDetails?.basicDetails.firstName,
      to: "",
      templatename: "",
      localFilePath: "",
      caption: "",
      body: data.text || "",
      type: "text",
      language: "pt-BR",
      previewUrl: true,
    };

    // 🔹 Envia para API
    const savedMessage = await sendMessage(params);

    //limpa input
    setReplyData(null);
  };

  /** ------------------- MESSAGE ACTIONS ------------------- **/
  const onDeleteMessage = (messageId: string | number) => {
    console.log("onDeleteMessage", messageId);
    // dispatch(deleteMessage(selectedChatId, messageId));
  };

  const onDeleteUserMessages = () => {
    console.log("onDeleteUserMessages", selectedChatId);
    // dispatch(deleteUserMessages(selectedChatId));
  };

  const onToggleArchive = () => {
    console.log("onToggleArchive", selectedChatId);
    // dispatch(toggleArchiveContact(selectedChatId));
  };

  const onDeleteImage = (messageId: string | number, imageId: string | number) => {
    console.log("onDeleteImage", messageId);
    // dispatch(deleteImage(selectedChatId, messageId, imageId));
  };

  const onOpenUserDetails = () => {
    openUserDetails();
  };

  const onSetImageSelf = async (messageId: string | number) => {
    console.log("onSetImageSelf", messageId);

    // 🔹 Envia para API
    if (!user?.id) return;
    if (!safeUser?.basicDetails.id) return;

    await contactsImage({ 'idUser': user.id, 'idContact': safeUser?.basicDetails.id, 'idMessage': messageId, 'typeImage': 1 });
    // console.log('[onSetImageSelf] ContactEdit ', contactEdited)
  };

  const onSetImageDocument = async (messageId: string | number) => {
    console.log("onSetImageDocument", messageId);

    // 🔹 Envia para API
    if (!user?.id) return;
    if (!safeUser?.basicDetails.id) return;

    await contactsImage({ 'idUser': user.id, 'idContact': safeUser?.basicDetails.id, 'idMessage': messageId, 'typeImage': 2 });
    // console.log('[onSetImageSelf] ContactEdit ', contactEdited)
  };

  const onSetImageResidence = async (messageId: string | number) => {
    console.log("onSetImageResidence", messageId);

    // 🔹 Envia para API
    if (!user?.id) return;
    if (!safeUser?.basicDetails.id) return;

    await contactsImage({ 'idUser': user.id, 'idContact': safeUser?.basicDetails.id, 'idMessage': messageId, 'typeImage': 3 });
    // console.log('[onSetImageSelf] ContactEdit ', contactEdited)
  };

  const onSetImageAttachment = async (messageId: string | number) => {
    console.log("onSetImageAttachment", messageId);

    // 🔹 Envia para API
    if (!user?.id) return;
    if (!safeUser?.basicDetails.id) return;

    await contactsImage({ 'idUser': user.id, 'idContact': safeUser?.basicDetails.id, 'idMessage': messageId, 'typeImage': 4 });
    // console.log('[onSetImageSelf] ContactEdit ', contactEdited)
  };


  /** ------------------- RENDER ------------------- **/
  return (
    <>
      {loading && <Loader />}
      <UserHead
        chatUserDetails={chatUserDetails}
        pinnedTabs={pinnedTabs}
        onOpenUserDetails={onOpenUserDetails}
        onDelete={onDeleteUserMessages}
        isChannel={isChannel}
        onToggleArchive={onToggleArchive}
      />

      <Conversation
        messages={conversationMessages || []}
        chatUserDetails={chatUserDetails || null}
        onDelete={onDeleteMessage}
        onSetReplyData={onSetReplyData}
        isChannel={isChannel}
        onDeleteImage={onDeleteImage}

        onSetImgSelf={onSetImageSelf}
        onSetImgDocument={onSetImageDocument}
        onSetImgResidence={onSetImageResidence}
        onSetImageAttachment={onSetImageAttachment}

      />

      <ChatInputSection
        onSendMessage={onSendMessage}
        replyData={replyData}
        onSetReplyData={onSetReplyData}
        chatUserDetails={safeUser || null}
        isBlocked={isBlocked}
        canOpenChat={canOpenChat}
        canSendFreeText={canSendFreeText}
      />
    </>
  );
};

export default Index;
